import CampusLogo from "../../../assets/logos/Campus-Logo.png";

const BRAND = "#E86A1F";

export default function CampusInlineLoading({
  title = "Loading Campus",
  detail = "Preparing your workspace...",
}) {
  return (
    <div style={styles.page}>
      <div style={styles.backdrop} />

      <div style={styles.content}>
        <div style={styles.logoWrap}>
          <img src={CampusLogo} alt="Campus logo" style={styles.logo} />
        </div>

        <div style={styles.badge}>Campus</div>

        <h2 style={styles.title}>{title}</h2>
        <p style={styles.detail}>{detail}</p>

        <div style={styles.loaderRow} aria-label={title} role="status">
          {[0, 1, 2].map((index) => (
            <span
              key={index}
              style={{
                ...styles.ball,
                animationDelay: `${index * 0.18}s`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    alignItems: "center",
    boxSizing: "border-box",
    display: "grid",
    justifyItems: "center",
    minHeight: "min(560px, calc(100dvh - 124px))",
    overflow: "hidden",
    padding: 24,
    placeItems: "center",
    position: "relative",
    width: "100%",
  },

  backdrop: {
    background: "rgba(255, 255, 255, 0.78)",
    backdropFilter: "blur(8px)",
    inset: 0,
    position: "absolute",
  },

  content: {
    maxWidth: 420,
    padding: "20px 24px",
    position: "relative",
    textAlign: "center",
    transform: "none",
    width: "100%",
  },

  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 16,
  },

  logo: {
    maxWidth: "82%",
    objectFit: "contain",
    width: 170,
  },

  badge: {
    alignItems: "center",
    background: "#fff",
    border: `1px solid ${BRAND}40`,
    borderRadius: 999,
    color: BRAND,
    display: "inline-flex",
    fontSize: 12,
    fontWeight: 700,
    justifyContent: "center",
    letterSpacing: "0.04em",
    marginBottom: 14,
    padding: "6px 12px",
    textTransform: "uppercase",
  },

  title: {
    color: BRAND,
    fontSize: 24,
    fontWeight: 700,
    margin: "0 0 10px",
  },

  detail: {
    color: "#475569",
    fontSize: 14,
    lineHeight: 1.5,
    margin: "0 0 22px",
  },

  loaderRow: {
    alignItems: "center",
    display: "flex",
    gap: 10,
    justifyContent: "center",
  },

  ball: {
    animationDuration: "0.9s",
    animationIterationCount: "infinite",
    animationName: "oikos-loading-bounce",
    animationTimingFunction: "ease-in-out",
    background: BRAND,
    borderRadius: 999,
    height: 14,
    width: 14,
  },
};
